import React from 'react';
import BatchConfigFormContainer from './BatchConfigFormContainer';

const CreateEditBatchConfigPage: React.FC = () => {
  return (
        <BatchConfigFormContainer />
  );
};

export default CreateEditBatchConfigPage;
